import React, { Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';

import { extractFromUrl } from '../../actions';

class ClipperHeader extends Component {
  constructor() {
    super();
    this.state = {
      url: null,
    };
    this.setState = this.setState.bind(this);
  }

  componentDidMount() {
    this.setState({ url: this.props.url });
  }

  render() {
    return (
      <div className="clipper-header">
        <div className="clipper-input">
          <form
            onSubmit={(e) => {
              e.preventDefault();
              this.props.dispatch(extractFromUrl(this.state.url));
              browserHistory.push('/clipper?url=' + this.state.url);
            }}
          >
            <input
              type="text"
              value={this.state.url}
              onChange={(e) => {
                this.setState({ url: e.target.value });
              }}
              className="form-control clipper-url"
              placeholder="Paste a url"
            />
            <button type="submit">Go</button>
          </form>
        </div>
      </div>
    );
  }
}

export default connect()(ClipperHeader);
